import React, { useCallback, useContext, useEffect, useState } from 'react';
import pluralize from 'pluralize';
import { Spinner } from '@amzn/awsui-components-core';
import { ContentEngagement } from '@amzn/awscat-pattern-library-service-model';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import { AppContext } from '../../contexts/AppContext';
import ContentEngagementButton from '../content-engagement/ContentEngagementButton';

interface ContentEngagementInfoProps {
  contentId: string;
  isCollection?: boolean;
}

const mplServiceClient: IMplServiceClient = MplServiceClientFactory.create();

const ContentEngagementInfo = ({ contentId, isCollection = false }: ContentEngagementInfoProps) => {
  const [engagements, setEngagements] = useState([]);
  const [hasEngagements, setHasEngagements] = useState(false);
  const [engagementCount, setEngagementCount] = useState<number>(0);
  const [hasLoaded, setHasLoaded] = useState<boolean>(false);

  const engagementSvg = '/images/ic_contact_group.svg';
  const activeEngagementSvg = '/images/ic_contact_group_active.svg';
  const iconUrl = hasEngagements ? activeEngagementSvg : engagementSvg;
  const appContext = useContext(AppContext);
  // @ts-expect-error TS18048 - strict migration
  const { userId } = appContext.authnInfo.userProfile;

  const initializeEngagements = useCallback(
    async (fetchedEngagements: ContentEngagement[]) => {
      // @ts-expect-error TS2345 - strict migration
      setEngagements(fetchedEngagements);
      setHasEngagements(fetchedEngagements?.length > 0 ? true : false);
      const engagementStatsResponse = await mplServiceClient.getContentEngagementStats(
        contentId,
        userId,
      );
      setEngagementCount(engagementStatsResponse.engagementCount);
    },
    [contentId, userId],
  );

  useEffect(() => {
    const fetchEngagements = async () => {
      const engagementsResponse = await mplServiceClient.getContentEngagements(contentId, userId);
      await initializeEngagements(engagementsResponse.contentEngagements);
      setHasLoaded(true);
    };
    fetchEngagements();
  }, [contentId, userId, initializeEngagements]);

  const updateEngagements = (updatedEngagements: ContentEngagement[]) => {
    // @ts-expect-error TS2345 - strict migration
    setEngagements(updatedEngagements);
    const updatedCount = engagementCount - engagements.length + updatedEngagements.length;
    setEngagementCount(updatedCount);
  };

  const renderEngagementCount = () => {
    return engagementCount > 0
      ? pluralize('engagement', engagementCount, true)
      : `Customer influences`;
  };

  if (!hasLoaded) {
    return <Spinner size="normal" />;
  }
  return (
    <ContentEngagementButton
      buttonVariant={'icon'}
      children={renderEngagementCount()}
      contentId={contentId}
      iconUrl={iconUrl}
      onFetch={initializeEngagements}
      onUpdate={updateEngagements}
      isCollection={isCollection}
    />
  );
};

export default ContentEngagementInfo;
